import {FormikValues} from 'formik'
import useSenderIdsOptions, {ISenderIdsOption} from '../../hooks/useSenderIdsOptions'
import {Dispatch, SetStateAction, useEffect} from 'react'
import Select, {
  ActionMeta,
  SingleValue,
  GroupBase,
  MenuListProps as SelectMenuListProps,
  InputActionMeta,
} from 'react-select'
import clsx from 'clsx'
import {ISelectOption} from '../../utils/core/_model'
import {FixedSizeList, ListChildComponentProps} from 'react-window'

type Props = {
  formik: FormikValues
  setDefaultSender: Dispatch<SetStateAction<ISenderIdsOption | null>>
}

const MenuList: React.FC<SelectMenuListProps<ISelectOption, false, GroupBase<ISelectOption>>> = ({
  options,
  children,
  maxHeight,
  getValue,
}) => {
  const [value] = getValue()
  const height = 35 // Height of each option
  const initialOffset = options.indexOf(value) * height

  // Ensure children is an array
  const childrenArray = Array.isArray(children) ? children : [children]

  return (
    <FixedSizeList
      height={maxHeight}
      width='100%' // Add width prop to satisfy FixedSizeList
      itemCount={childrenArray.length}
      itemSize={height}
      initialScrollOffset={initialOffset}
    >
      {({index, style}: ListChildComponentProps) => <div style={style}>{childrenArray[index]}</div>}
    </FixedSizeList>
  )
}

const SelectSender = ({formik, setDefaultSender}: Props) => {
  const {senderIdsOptions, defaultSender} = useSenderIdsOptions()

  useEffect(() => {
    formik.setFieldValue('senderid', defaultSender[0])
    setDefaultSender(defaultSender[0])

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSender])

  return (
    <Select
      name='senderid'
      className={clsx(
        'react-select-styled react-select custom-input',
        {'is-invalid': formik.touched.senderid && formik.errors.senderid},
        {
          'is-valid': formik.touched.senderid && !formik.errors.senderid,
        }
      )}
      classNamePrefix='react-select'
      placeholder='Choose year value'
      value={formik.values.senderid}
      onChange={(selectedOption) => {
        formik.setFieldValue('senderid', selectedOption)
      }}
      options={senderIdsOptions}
      components={{MenuList}}
    />
  )
}

export default SelectSender
